<div class="ui-g ui-grid-responsive ui-fluid">
  <div class="ui-g-12">
    <div class="ui-grid-col-5">
      <div *ngIf="isLoading" style="text-align: center; font-size: 1.25rem">
        <i class="fa fa-spinner fa-spin"></i>&nbsp; Loading Tasks
      </div>

      <p-table
        [value]="driverPlanJobs"
        styleClass="no-header"
        emptyMessage=""
        scrollable="true"
        [style]="{ 'margin-right': '10px' }"
      >
        <ng-template pTemplate="body" let-item>
          <tr>
            <td>
              <div class="ui-g">
                <div class="ui-g-12">
                  <a class="bold" href="/app/jobscreen/{{ item.id }}" target="_blank">{{
                    item.jobNumber
                  }}</a>
                </div>
                <div *ngFor="let task of item.tasks" class="ui-g-12">
                  <span
                    >{{ task.pickupEarliestDateTime | datex : 'ddd DD MMM HH:mm' }} -
                    {{ task.pickupLatestDateTime | datex : 'ddd DD MMM HH:mm' }}
                    {{ task.customerInfo?.name }}</span
                  >
                </div>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>

      <!-- DATATABLE DEPRECATED ---

      <p-dataTabl [value]="driverPlanJobs"
                   styleClass="no-header" emptyMessage=""
                   scrollable="true"
                   [style]="{'margin-right':'10px'}">
          <p-column header="" rowHover="false">
              <ng-template let-item="rowData" pTemplate="body">
                  <div class="ui-g">
                      <div class="ui-g-12">
                          <a class="bold" href="/app/jobscreen/{{ item.id }}" target="_blank">{{ item.jobNumber }}</a>
                      </div>
                      <div *ngFor="let task of item.tasks" class="ui-g-12">
                          <span>{{ task.pickupEarliestDateTime | datex: 'ddd DD MMM HH:mm' }} - {{ task.pickupLatestDateTime | datex: 'ddd DD MMM HH:mm' }} {{ task.customerInfo?.name }}</span>
                      </div>
                  </div>
              </ng-template>
          </p-column>

      </p-dataTable>

      --->
    </div>
    <div class="ui-grid-col-7">
      <map-control
        #driverPlanMap
        [tasks]="tasks"
        [plannedTasks]="driverPlanTasks"
        [organisations]="supplierHouse"
        [readOnly]="true"
        [customStyle]="{ height: '650px' }"
      ></map-control>
    </div>
  </div>
</div>
